module.exports = __webpack_public_path__ + "static/media/support10_small_banner.060ec99f.jpg";